import React,{useState} from 'react';
import {Link} from 'react-router-dom';
import {
    Form, Input, Label, FormGroup,
    Card, CardBody, Button, Row
} from '@Comp';
import { View } from '../../../shared/components';

import images from '@assets';
import '../style.scss';
import {inject} from "mobx-react";

const ForgetPassPage = ({commonStore}) =>{

   const [businessEmailAddress, setBusinessEmailAddress] = useState('');
   const [err, setErr] = useState(null);
   const handleSubmit = (e) =>{
       e.preventDefault();
       commonStore.setLoading(true);
       commonStore.forgetPassword(businessEmailAddress).then((ret) => {
            commonStore.setLoading(false);
            setErr("Email With Reset Password Details Successfully Sent");
        }).catch((e) => {
            commonStore.setLoading(false);
            setErr("System Error -  Contact Admin.");
        });

   };

    return(
        <View>
            <div className="view-content view-content-forgot view-pages view-session d-flex justify-content-center align-items-center flex-column">
            <Row className="no-gutters">
                <Card className="mb-3 forgot-card">
                    <CardBody className="forgot-card-body">
                        <header className="mb-4 text-center">
                            <img className="forgot-logo img-fluid mb-4" src={images.nisaFinanceDarkLogo} alt="NISA Finance Logo" />
                            <h2 className="forgot-title">Reset Password</h2>
                            <p className="forgot-subtitle">Enter your email address and we'll send you the instructions for resetting the password.</p>
                        </header>
                        <Form onSubmit={handleSubmit} className="forgot-form">
                            <FormGroup className="mb-4">
                                <Label className="forgot-label">Business Email Address</Label>
                                <Input
                                    className="forgot-input"
                                    type="email"
                                    name="email"
                                    value={businessEmailAddress}
                                    placeholder="yourmail@xyz.com"
                                    onChange={(e)=>setBusinessEmailAddress(e.target.value)}
                                />
                            </FormGroup>
                            {err && <p className="forgot-error">{err}</p>}
                            <FormGroup className="text-right">
                                <Button className="btn-forgot-reset" type="submit">Reset Password</Button>
                            </FormGroup>
                        </Form>
                        <p className="forgot-login-link">Already have an account? <Link to="/login">Login</Link></p>
                    </CardBody>
                </Card>
            </Row>
            </div>
        </View>
        )

};

const ForgetPassword = inject("commonStore")(ForgetPassPage);
export default ForgetPassword;
